import { Badge } from '../../../../ui/badge';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../../ui/select';
import type { BaseFieldProps, SelectFieldSchema } from '../../../types';

export function SelectFieldInput({
  field,
  value,
  onChange,
  error,
}: BaseFieldProps<SelectFieldSchema, string | string[] | null | undefined>) {
  const selectValue = Array.isArray(value) ? value[0] : value;

  return (
    <Select value={(selectValue as string) || ''} onValueChange={(val) => onChange?.(val)}>
      <SelectTrigger id={field.id} aria-invalid={!!error}>
        <SelectValue placeholder={field.placeholder || 'Select an option'} />
      </SelectTrigger>
      <SelectContent>
        {field.options?.map((option) => (
          <SelectItem key={option} value={option}>
            {option}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export function SelectFieldView({
  field: _field,
  value,
  viewPlaceholder,
}: BaseFieldProps<SelectFieldSchema, string | string[] | null | undefined>) {
  if (
    value === undefined ||
    value === null ||
    value === '' ||
    (Array.isArray(value) && value.length === 0)
  ) {
    return <span className="text-muted-foreground text-sm">{viewPlaceholder || '- -'}</span>;
  }

  if (Array.isArray(value)) {
    return (
      <div className="flex flex-wrap gap-1">
        {value.map((val) => (
          <Badge key={val} variant="secondary">
            {val}
          </Badge>
        ))}
      </div>
    );
  }

  return <span className="text-sm font-medium">{value}</span>;
}
